import { FC, PropsWithChildren } from 'react';

import { HttpError } from '@bonusly/http';
import { useCurrentUser } from '@bonusly/who-am-i';

type AdminLabel = 'global' | 'finance' | 'rewards' | 'awards' | 'announcements' | 'reports' | 'techOps' | 'super' | 'peopleData';
type AdminRole =
	| 'admin'
	| 'finance_admin'
	| 'global_admin'
	| 'rewards_admin'
	| 'awards_admin'
	| 'announcements_admin'
	| 'reports_admin'
	| 'tech_ops_admin'
	| 'people_data_admin'
	| 'super_admin';

const RoleMap: Record<AdminLabel, AdminRole> = {
	global: 'admin',
	finance: 'finance_admin',
	rewards: 'rewards_admin',
	awards: 'awards_admin',
	announcements: 'announcements_admin',
	reports: 'reports_admin',
	techOps: 'tech_ops_admin',
	super: 'super_admin',
	peopleData: 'people_data_admin',
};

type RequireAdminProps = PropsWithChildren & {
	require: AdminLabel | AdminLabel[];
	/** HTTP status when user lacks required role (default 404). Use 403 for forbidden. */
	statusCode?: number;
};

export const RequireAdmin: FC<RequireAdminProps> = ({ children, require, statusCode = 404 }) => {
	const user = useCurrentUser();
	const requireArray = Array.isArray(require) ? require : [require];
	const isAdmin = requireArray.some((role) => user[RoleMap[role]]);

	if (isAdmin) {
		return <>{children}</>;
	}

	throw new HttpError(statusCode);
};
